export default __webpack_public_path__ + "locales/ar-SA/DeleteDialog.json?hash=3b0804df05f307c2286e3b7629c5100e";